module.exports = "<scene></scene>"


//////////////////
// WEBPACK FOOTER
// C:/Users/s6ccq3/git/angular-three-examples/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main